import { DateTime, Duration } from "luxon";

export const formatTimeTick = (ms: any) => {
  const duration = Duration.fromMillis(Math.abs(ms));
  let timeString;
  if (duration.shiftTo("hours").get("hours") >= 1) {
    timeString = duration.toFormat("h:mm:ss");
  } else {
    timeString = duration.toFormat("m:ss");
  }
  return ms < 0 ? `-${timeString}` : timeString;
};

const ONE_HOUR_MS = 60 * 60 * 1000;

/**
 * @param startTime Time at which the other time is relative to
 * @param time Time for which to create the relative timestamp
 * @return ms The millisecond difference between the two times
 * */
export const msDurationBetween = (
  startTime: DateTime,
  time: DateTime
): number => {
  return time.diff(startTime).toMillis();
};

export const getFormattedTimestampFromMs = (millis: number) => {
  if (millis > ONE_HOUR_MS) {
    return Duration.fromMillis(millis).toFormat("h:mm:ss");
  }
  return Duration.fromMillis(Math.max(millis, 0)).toFormat("m:ss");
};

/**
 * @param startTime Time at which the other time is relative to
 * @param time Time for which to create the relative timestamp
 * @return timestamp Formatted timestamp of relative time (e.g. "1:34")
 * */
export const getRelativeTimestamp = (startTime: DateTime, time: DateTime) => {
  const msDiff = msDurationBetween(startTime, time);
  return getFormattedTimestampFromMs(msDiff);
};

const AFTERNOON_CUTOFF = 12; // 12PM
const EVENING_CUTOFF = 17; // 5PM

/**
 * Gets a humanized greeting based on time of day
 * @returns "morning", "afternoon", or "evening"
 */
export const getGreetingTime = (time: DateTime = DateTime.local()) => {
  const currentHour = time.hour;
  if (currentHour >= AFTERNOON_CUTOFF && currentHour < EVENING_CUTOFF)
    return "afternoon";
  if (currentHour >= EVENING_CUTOFF) return "evening";
  return "morning";
};

/**
 * @param dateTime DateTime object to be formatted
 * @return formatted locale string
 * */
export const formatTime = (dateTime: DateTime): string => {
  return dateTime.toLocaleString(DateTime.TIME_SIMPLE);
};
